import React, { useState } from 'react'
import './style.css'
import { CaretDown, Check } from '@phosphor-icons/react'

export default function Select({ placeholder, value, data, setValue, isFont, width, isEditable }) {
  const [open, setOpen] = useState(false)
  return (
    <div tabIndex={0} onBlur={(e) => {
      if (e.currentTarget.contains(e.relatedTarget)) {
        return
      }
      setOpen(false)
    }}>
      <div className='Select' style={{minWidth:width, maxWidth:width || null}} onClick={() => setOpen(!open)}>
        {open && isEditable?
        <input onClick={(e)=>e?.stopPropagation()} value={value} placeholder={placeholder}/>
        :
        <p style={{ color: value ? "#000" : "" }}>{value || placeholder}</p>
        }
        <CaretDown className={open? 'Select_Arrow Select_Arrow_Open' : 'Select_Arrow'} weight='bold' />
        <div className={open ? 'Select_Con Select_Con_Open' : 'Select_Con'}>
          {data?.map((item, index)=>{
            return (
              <div key={index} style={{borderTop: index === 0? 'none':null, fontFamily: isFont? item : null}} className='Select_Option_Con' onClick={()=>setValue? setValue(item) : null }>
                {item}
                <div className='FlexCon'/>
                {value === item? <Check weight='bold' size={14}/> : null}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
